
import { computed, defineComponent } from 'vue';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';

export default defineComponent({
  name: 'CampoCnpj',
  components: {
  },
  props: {
    valor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor', 'blur'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: string) => {
        if (valor === undefined || valor === null) {
          emit('update:valor', '');
        } else {
          emit('update:valor', UtilitarioMascara.removerMascara(valor));
        }
      },
    });

    function blur() {
      emit('blur');
    }

    return {
      props,
      computedValor,
      UtilitarioMascara,
      blur,
    };
  },
});
